import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { txnTableColumns } from '../../../app/app-constant';
import { TagsService } from '../../services/tags.service';

@Component({
  selector: 'app-search-table',
  templateUrl: './search-table.component.html',
  styleUrls: ['./search-table.component.css']
})
export class SearchTableComponent implements OnInit {
  
  searchInput: any;
  suggestions = [];
  @Input() cols;
  
  @Output() searchEvent: any  = new EventEmitter();

  constructor(private tagsService: TagsService) { }

  ngOnInit() {
  }

  search() {
    //console.log(this.searchInput, JSON.stringify(this.cols));
    let input = '';
    if(typeof this.searchInput == 'object') {
      if(this.searchInput.header.indexOf(': ') > -1) {
        input = this.searchInput.field+': '+this.searchInput.header.split(': ')[1];
      } else {
        input = this.searchInput.field ? (this.searchInput.field+': '+this.searchInput.header) : 'ALL: '+this.searchInput.header;
      }
    } else {
      if(this.searchInput.indexOf(': ') > -1) {
        let columnHeader = this.searchInput.split(': ')[0];
        for(let colObj of this.cols) {
          if(colObj.header == columnHeader) {
            input = colObj.field+': '+this.searchInput.split(': ')[1];
          }
        }
      } else {
        input = 'ALL: '+this.searchInput;
      }
    }
    this.searchEvent.next(input);

    this.tagsService.link({
      "event_action" : "button click",
      "event_content": "search box : search icon"
    });
  }

  clear() {
    this.searchInput = '';
    this.searchEvent.next('');

    this.tagsService.link({
      "event_action" : "sutton click",
      "event_content": "search box : clear search icon"
    });
  }

  //searchInput = { field: 'customerName', header: 'Customer' };

  autoSuggestSearch(event) {
      //console.log(event, this.cols);
      this.cols = this.cols.filter(val => 
        [
          //txnTableColumns.DV_TXN_ID, 
          txnTableColumns.TXN_DATE, txnTableColumns.AMOUNT_QUANTITY].indexOf(val.header) == -1
      );
      let enteredVal;
      let modifiedCols = this.cols.map(obj => {
        enteredVal = event.query.indexOf(':') > -1 ? event.query.split(': ')[1] : event.query;
        let resObj = Object.assign({}, obj);
        resObj.header = resObj.header+': '+enteredVal;
        return resObj;
      });
      this.suggestions = [{field: '', header: enteredVal}].concat(modifiedCols);

      this.tagsService.link({
        "event_action" : "text entry",
        "event_content": "search box : text entered"
      });
  }

}
